// eslint-disable-next-line no-unused-vars
import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import verifierDroits from './verifierDroits.func';

const VerifierDroitsComponent = ({ dataProfil, droits, droitsInterdits, children }) => {
    if (droitsInterdits && !verifierDroits(dataProfil, droitsInterdits)) {
        return children;
    }

    if (verifierDroits(dataProfil, droits)) {
        return children;
    }

    return null;
};

VerifierDroitsComponent.propTypes = {
    droits: PropTypes.array.isRequired,
    droitsInterdits: PropTypes.array,
    dataProfil: PropTypes.shape({
        roles: PropTypes.array.isRequired,
    }),
    children: PropTypes.any,
};

export default connect((state) => {
    const { data: dataProfil } = state.profil.usager;
    return {
        dataProfil,
    };
})(VerifierDroitsComponent);
